@if ({}; as STATE) {
  <article class="card-details">
    <button
      type="button"
      class="card-details__close-button"
      mat-dialog-close
      [matTooltip]="'Fermer'"
      aria-label="Fermer"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path
          fill="currentColor"
          d="m6.4 18.308l-.708-.708l5.6-5.6l-5.6-5.6l.708-.708l5.6 5.6l5.6-5.6l.708.708l-5.6 5.6l5.6 5.6l-.708.708l-5.6-5.6z"
        />
      </svg>
    </button>
    <section>
      <hgroup class="card-details__header">
        <div>
          <h2>{{ advertisers()?.name }}</h2>
          <p>Créée le : {{ advertisers()?.createdAt | date: 'dd/MM/yyyy' }}</p>
        </div>
        <span
          ><img img="advertisers()?.name" alt="{{ advertisers()?.name }}"
        /></span>
      </hgroup>
      <div class="card-details__table__wrapper">
        <table>
          <tbody>
            <tr>
              <td>Pays</td>
              <td>{{ advertisers()?.country | isoToCountry }}</td>
            </tr>
            <tr>
              <td>Adresse</td>
              <td>{{ advertisers()?.address }}</td>
            </tr>
            <tr>
              <td>Email</td>
              <td>{{ advertisers()?.email }}</td>
            </tr>
            <tr>
              <td>Numéro de téléphone</td>
              <td>{{ advertisers()?.phoneNumber }}</td>
            </tr>
            <tr>
              <td>Description</td>
              <td>{{ advertisers()?.description }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </article>
}
